import { required, requiredIf, minLength, email, maxValue as vuelidateMaxValue } from 'vuelidate/lib/validators'

export const formValidators = {
  required: () => required,
  requiredIf: (params, formFields) => {
    if (typeof params === 'function') {
      return requiredIf(() => params(formFields))
    }
    return requiredIf(params)
  },
  minLength: (n) => minLength(...n),
  email: () => email,
  maxValue: (params, formFields) => {
    const maxVal = typeof params.max === 'function' ? params.max(formFields) : params.max
    return vuelidateMaxValue(Number(maxVal))
  }
}
